import mutation from './mutation.graphql.js'
import { useMutation } from 'Data/Api'
import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data, reExecuteQuery) {
  let [, executeMutation] = useMutation(mutation)
  let patient = useDataValue({
    context: 'patient',
    viewPath: props.viewPath,
  })

  return async function onSubmit({ value, originalValue, args, change }) {
    await executeMutation({
      patient_id: patient._id,
      organization_id: patient.primary_location._id,
    })

    await reExecuteQuery()
  }
}
